import { configureStore } from '@reduxjs/toolkit';
import mainReducers from './mainSlice';
import sliderReducers from './sliderSlice';

export default configureStore({
    devTools: window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(),
    reducer: {
        main: mainReducers,
        slider: sliderReducers,
    },
});
